import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero, SectionHead } from "@/components/site/Blocks";
import PricingCards from "@/components/site/PricingCards";
import { CtaBand } from "@/components/site/Cta";
import { getLocation } from "@/data/locations";
import { MAIN_SERVICES } from "@/data/services";
import { BRAND, EMAIL, PHONE, SITE_URL } from "@/data/site";

export default function LocalPage({ slug }) {
  const l = getLocation(slug);
  const crumbs = [{ label: "Home", to: "/" }, { label: l.h1, to: `/${l.slug}` }];
  const ld = { "@context": "https://schema.org", "@type": "ProfessionalService", name: `${BRAND} ${l.city}`, url: `${SITE_URL}/${l.slug}`, email: EMAIL, telephone: PHONE, address: { "@type": "PostalAddress", streetAddress: l.address.split(",")[0], addressLocality: l.city, addressCountry: "IT" }, areaServed: "IT" };
  return (
    <>
      <Seo path={`/${l.slug}`} title={l.title} description={l.description} jsonLd={[crumbsLd(crumbs), ld]} />
      <PageHero crumbs={crumbs} eyebrow={`Sede di ${l.city}`} title={l.h1} intro={l.intro}>
        <Link to="/consulenza-online" className="btn-primary">Prenota una consulenza <ArrowRight className="h-4 w-4" /></Link>
      </PageHero>
      <section className="py-14 md:py-20">
        <div className="wrap grid gap-14 lg:grid-cols-[1.2fr_0.8fr]">
          <div>
            <h2 className="text-2xl font-bold sm:text-3xl">Lavorare con noi a {l.city}</h2>
            <p className="lead-text mt-4">{l.body}</p>
            <p className="lead-text mt-4">La sede riceve su appuntamento: scrivici per fissare un incontro. Progettazione, sviluppo e gestione avvengono principalmente da remoto, come per i clienti nel resto d’Italia.</p>
            <h2 className="mt-14 text-2xl font-bold sm:text-3xl">Servizi disponibili</h2>
            <div className="mt-6 flex flex-wrap gap-2">
              {MAIN_SERVICES.map((s) => <Link key={s.slug} to={`/servizi/${s.slug}`} className="rounded-full border border-slate-200 px-4 py-2 text-sm font-medium hover:border-slate-900">{s.name}</Link>)}
            </div>
          </div>
          <div className="card h-fit p-7">
            <MapPin className="h-5 w-5 text-blue-600" />
            <p className="mt-4 font-display text-xl font-bold">{BRAND} — {l.city}</p>
            <p className="mt-1 text-slate-600">{l.address}</p>
            <p className="mt-4 text-sm text-slate-600">Ricevimento su appuntamento. {EMAIL} · {PHONE}</p>
          </div>
        </div>
      </section>
      <section className="bg-soft py-14 md:py-20">
        <div className="wrap">
          <SectionHead eyebrow="Prezzi" title="Gli stessi prezzi chiari, in ogni città" intro="Prezzi IVA esclusa." />
          <div className="mt-12"><PricingCards compact /></div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
